module.exports = __webpack_public_path__ + "assets/df9f7dbe8d9030c9624139e775bd7b16.svg";